// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PartnerScoreVm from "../../view-model/PartnerScoreVm.bs.js";
import * as PartnerScoreCmp from "./PartnerScoreCmp.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PartnerScoreErrorCmp from "./PartnerScoreErrorCmp.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PartnerScoreRepoManager from "../../../domain/repo/PartnerScoreRepoManager.bs.js";
import * as PartnerScoreStateMachine from "../../state-manager/PartnerScoreStateMachine.bs.js";

function PartnerScoreDashboard(Props) {
  var msisdn = Props.msisdn;
  var auth_token = Props.auth_token;
  var language = Props.language;
  var vehicle_category = Props.vehicle_category;
  var geo_region = Props.geo_region;
  var match = React.useReducer(PartnerScoreStateMachine.reducer, PartnerScoreStateMachine.initialState);
  var dispatch = match[1];
  var fetchPartnerScoreApiCall = function (param) {
    var RepoInstance = PartnerScoreRepoManager.getRepo(undefined);
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(RepoInstance.fetchPartnerScore, msisdn, auth_token);
                }), (function (score) {
                  return Curry._1(dispatch, /* UpdateScore */{
                              _0: {
                                TAG: /* Live */1,
                                _0: score
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, /* UpdateScore */{
                              _0: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }));
  };
  React.useEffect((function () {
          fetchPartnerScoreApiCall(undefined);
          
        }), []);
  var score = match[0].partner_score;
  if (typeof score === "number") {
    return null;
  }
  switch (score.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var score_view_model = PartnerScoreVm.getVm(score._0);
        if (List.length(score_view_model) > 0) {
          return React.createElement(PartnerScoreCmp.make, {
                      msisdn: msisdn,
                      geo_region: geo_region,
                      scores: score_view_model,
                      language: language,
                      vehicle_category: vehicle_category
                    });
        } else {
          return React.createElement(PartnerScoreErrorCmp.make, {
                      reload_cb: fetchPartnerScoreApiCall
                    });
        }
    case /* Error */2 :
        return React.createElement(PartnerScoreErrorCmp.make, {
                    reload_cb: fetchPartnerScoreApiCall
                  });
    
  }
}

var make = PartnerScoreDashboard;

export {
  make ,
  
}
/* react Not a pure module */
